/**
 * Trang route cho form tạo/sửa BĐS trong admin.
 *
 * Phân nhánh theo URL param `id`:
 * - Có `id`: render AdminPropertyEditModal (chỉnh sửa BĐS hiện có).
 * - Không có `id`: render AdminPropertyCreateModal (tạo mới).
 *
 * Quyền duyệt BĐS (canReviewProperty) chỉ dành cho super admin.
 */
import { useNavigate, useParams } from 'react-router-dom';
import { AdminPropertyCreateModal } from '../../components/admin/AdminPropertyCreateModal';
import { AdminPropertyEditModal } from '../../components/admin/AdminPropertyEditModal';
import { useAuth } from '../../hooks/useAuth';
import { APP_ROUTES } from '../../shared/constants/routes';
import { USER_ROLES } from '../../shared/constants/users';

/** Trang wrapper modal tạo hoặc chỉnh sửa BĐS */
export const AdminPropertyFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const canReviewProperty = user?.role === USER_ROLES.superAdmin;

  const handleClose = () => {
    navigate(-1);
  };

  const handleSaved = () => {
    navigate(APP_ROUTES.adminProperties);
  };

  if (id) {
    return (
      <AdminPropertyEditModal
        propertyId={id}
        canReviewProperty={canReviewProperty}
        userRole={user?.role}
        onClose={handleClose}
        onSaved={handleSaved}
      />
    );
  }

  return (
    <AdminPropertyCreateModal
      isOpen
      canReviewProperty={canReviewProperty}
      userRole={user?.role}
      onClose={handleClose}
      onSaved={handleSaved}
    />
  );
};
